import React from 'react';
/**
 * @ignore - internal component.
 */

var ListContext = React.createContext({});
export default ListContext;